import { render, staticRenderFns } from "./CreateBloodSampleForm.vue?vue&type=template&id=3ec8b616&scoped=true"
import script from "./CreateBloodSampleForm.vue?vue&type=script&lang=js"
export * from "./CreateBloodSampleForm.vue?vue&type=script&lang=js"
import style0 from "./CreateBloodSampleForm.vue?vue&type=style&index=0&id=3ec8b616&prod&lang=scss&scoped=true"
import style1 from "./CreateBloodSampleForm.vue?vue&type=style&index=1&id=3ec8b616&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8b616",
  null
  
)

export default component.exports